/**
 * Kebijakan password yang DIPILIH PENGGUNA SENDIRI — satu sumber untuk tiga
 * layar: Ganti Password (Pengaturan Saya), Wajib Ganti Password (login
 * pertama), dan Lupa Password (reset lewat Google Authenticator).
 *
 * Server tetap hakimnya (`routers/auth.py::pastikan_password_baru_sah`):
 * daftar password umum, deret angka/huruf, dan "tidak sama dengan username/
 * email/NIK" hanya diperiksa di sana, lalu pesannya ditampilkan apa adanya.
 * Di sini cuma pemeriksaan murah yang pasti sama hasilnya, supaya pengguna
 * tidak menunggu jaringan untuk kesalahan yang jelas.
 *
 * Password SEMENTARA yang diketik admin/HR untuk orang lain (Kelola Pengguna,
 * Data Karyawan) SENGAJA tidak memakai aturan ini — tetap minimal 6, karena
 * wajib diganti pemiliknya saat login pertama.
 */
export const PASSWORD_MIN = 8;

export const ATURAN_PASSWORD =
  "Minimal 8 karakter, bukan cuma spasi, tidak sama dengan username/email/NIK Anda, dan bukan " +
  "password pasaran seperti 12345678 atau password123.";

/** Pesan galat untuk ditampilkan, atau "" kalau lolos pemeriksaan layar. */
export function periksaPasswordBaru(pw) {
  const s = (pw || "").trim();
  if (!s) return "Password baru tidak boleh kosong atau hanya berisi spasi";
  if (s.length < PASSWORD_MIN) return `Password baru minimal ${PASSWORD_MIN} karakter`;
  return "";
}
